import React from "react";
import { LineChart as ReLineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";

interface SurveyData {
  year: number;
  quarter: string;
  total_surveys_Assessment: number;
}

interface LineChartProps {
  data: SurveyData[];
}

const  LineChartSurvey: React.FC<LineChartProps> = ({ data }) => {
  // Format the data to display "Year QX" on the x-axis
  const formattedData = data?.map((item) => ({
    name: `${item.year} ${item.quarter}`,
    total: item.total_surveys_Assessment,
  }));

  return (
    <ResponsiveContainer width="100%" height={300}>
      <ReLineChart data={formattedData} margin={{ top: 20, right: 30, left: 20, bottom: 20 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Line type="monotone" dataKey="total" stroke="#8884d8" strokeWidth={2} dot={{ r: 4 }} />
      </ReLineChart>
    </ResponsiveContainer>
  );
};

export default LineChartSurvey;
